export default [
  'ar',
  'ar-XB',
  'bg',
  'bs',
  'bs-Cyrl',
  'cs',
  'da',
  'de',
  'el',
  'en',
  'en-XA',
  'en-XC',
  'es',
  'et',
  'fi',
  'fr',
  'fr-CA',
  'he',
  'hr',
  'hu',
  'is',
  'it',
  'ja',
  'ko',
  'lt',
  'lv',
  'ms',
  'nl',
  'no',
  'pl',
  'pt',
  'pt-PT',
  'ro',
  'ru',
  'sk',
  'sl',
  'sr',
  'sr-Latn',
  'sv',
  'th',
  'tr',
  'uk',
  'vi',
  'zh-Hans',
  'zh-Hant'
];
